import { render, staticRenderFns } from "./AssessmentDocuments.vue?vue&type=template&id=24e389a2"
import script from "./AssessmentDocuments.vue?vue&type=script&lang=js"
export * from "./AssessmentDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports